import {makeAutoObservable} from "mobx";
import GlobalService from "./services/global.service";
import {toast} from "react-toastify";

export class GlobalStore {
    status = {}
    isOpen = true
    list = []
    isShowTimers = false
    isShowTvSwitcher = false
    isShowReplication = false
    isShowSocketTurn = false

    constructor() {
        makeAutoObservable(this)
    }

    setIsShowSocketTurn(isShowSocketTurn) {
        this.isShowSocketTurn = isShowSocketTurn
    }

    setIsShowTimers(isShowTimers) {
        this.isShowTimers = isShowTimers
    }

    setIsShowTvSwitcher(isShowTvSwitcher) {
        this.isShowTvSwitcher = isShowTvSwitcher
    }

    setIsShowReplication(isShowReplication) {
        this.isShowReplication = isShowReplication
    }

    setStatus(status) {
        this.status = status
    }

    setOpen(isOpen) {
        this.isOpen = isOpen
    }

    setList(list) {
        this.list = list
    }

    async getStatus() {
        try {
            const res = await GlobalService.getStatus()
            this.setStatus(res.data)
            this.setOpen(res.data?.is_created)
            this.setIsShowTimers(res.data?.is_show_timers)
            this.setIsShowTvSwitcher(res.data?.is_show_tv_switcher)
            this.setIsShowReplication(res.data?.is_show_replication)
            this.setIsShowSocketTurn(res.data?.is_socket_turn_off)
        } catch (e) {
            console.log(e)
        }
    }

    async getList() {
        try {
            const res = await GlobalService.getList()
            this.setList(res.data.competitions)
        } catch (e) {
            console.log(e)
        }
    }

    async chooseSelect(id) {
        try {
            const res = await GlobalService.chooseSelect(id)
            console.log(res)
            if (res.data.status === "ok") {
                this.setOpen(!res.data?.is_created)
            } else {
                toast.error(res.data?.msg || 'Ошибка')
            }

        } catch (e) {
            console.log(e)
        }
    }
}
